module.exports = __webpack_public_path__ + "img/x4.b58af436.jpg";